const i18next = require('i18next');
const $ = require('jquery');
const LanguageDetector = require('i18next-browser-languagedetector');
const Backend = require('i18next-xhr-backend');
const Cache = require('i18next-localstorage-cache');
const Ui = require('./Ui');

class Localization {
  constructor() {
    this.options = {
      load: 'languageOnly',
      fallbackLng: 'en',
      backend: {
        loadPath: `./lang/{{lng}}.json?v=${window.globalVersion}`,
        crossDomain: false,
      },
    };
  }

  /**
   *
   * @return {Promise<any>}
   */
  init(language) {
    if (language) {
      this.currentLanguage = language;
      this.options.lng = language;
    }

    return new Promise((resolve, reject) => {
      i18next
        .use(Backend)
        .use(Cache)
        .use(LanguageDetector)
        .init(this.options)
        .then(() => {
          this.currentLanguage = i18next.languages[0]; // eslint-disable-line
          this.initLanguagePicker();
          Ui.translateElements();

          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  initLanguagePicker() {
    const markItemAsSelected = (item) => {
      $('#language-picker-current-language').html(item.html());
      $('#language-picker .dropdown-item').show();
      item.hide();
    };

    $('#language-picker .dropdown-item').each((index, element) => {
      const item = $(element);

      item.on('click', () => {
        this.currentLanguage = item.data('language');
        i18next.changeLanguage(item.data('language'), () => {
          markItemAsSelected(item);
          Ui.translateElements();
        });
      });

      if (item.data('language') === this.currentLanguage) {
        markItemAsSelected(item);
      }
    });
  }

  // noinspection JSMethodCanBeStatic
  translationExists(key) { // eslint-disable-line
    return i18next.exists(key);
  }

  // noinspection JSMethodCanBeStatic
  translate(key, params) { // eslint-disable-line
    return i18next.t(key, params);
  }

  get language() {
    return this.currentLanguage;
  }
}

module.exports = Localization;
